import { Component } from '@angular/core';

@Component({
  selector: 'shaft-seal-product-search-app',
  template: `
    <div class='pyi-product-search-app'>
      <shaft-seal-product-selector></shaft-seal-product-selector>
    </div>
  `
})
export class AppComponent {}



// WEBPACK FOOTER //
// ./app/javascript/product_search/app/app.component.ts